<template>
  <div v-if="spaceInfoDataModelValue"
       class="space-detail">
    <div class="space-info-scroll">
      <SpacePhotoSwiper :space-photo-obj="spaceInfoDataModelValue.photos"
                        :space-name="spaceInfoDataModelValue.name"></SpacePhotoSwiper>
      <div class="space-info-wrap">
        <h1 class="name">{{ spaceInfoDataModelValue.name }}</h1>
        <div class="address point"
             @click="scrollToMap">
          <div>{{
              spaceInfoDataModelValue.city + spaceInfoDataModelValue.region + spaceInfoDataModelValue.address
            }}
          </div>
          <svg-icon name="distance"
                    size="16"></svg-icon>
        </div>
        <div v-if="spaceInfoDataModelValue.traffic && spaceInfoDataModelValue.traffic.length > 0"
             class="traffic">
          <svg-icon name="railway"
                    size="16"
                    class="mr-1"></svg-icon>
          {{ parseRentMRT(spaceInfoDataModelValue.traffic) }}
        </div>
        <div class="flex items-center mb-[4px] text-[18px] text-black">
          <el-icon class="mr-2">
            <User size="16"/>
          </el-icon>
          {{ spaceInfoDataModelValue.number_of_people_max + '人' }}
        </div>
        <div class="flex items-center mb-[4px] text-[18px] text-black">
          <svg-icon size="16"
                    class="mr-[4px]"
                    name="width"/>
          {{ `${spaceInfoDataModelValue.room_size} ${$t('space.room_unit')}` }}
        </div>


<!--        <div class="flex mb-[10px] flex-col">
                    <div class="flex">
                      <div v-for="tag in handleSpaceUsageArray(spaceInfoDataModelValue.categories)"
                           class="tag bg-osn-dark-grey-00">{{ tag.name }}
                      </div>
                    </div>
          <div class="mt-2 flex">
            <div v-for="tag in handleSpaceTypeArray(spaceInfoDataModelValue.categories)"
                 class="tag bg-osn-grey-00">{{ tag.name }}
            </div>
          </div>
                    <div class="mt-2 flex">
                      <div v-for="tag in handleSpaceTagArray(spaceInfoDataModelValue.categories)"
                           class="tag bg-osn-grey-01">{{ tag.name }}
                      </div>
                    </div>
        </div>-->
        <SpacePriceWrapper :space-rent-obj="spaceInfoDataModelValue.rent"/>
        <ConfirmationRequirementText :hint-model="true"
                                     :need-be-confirm="spaceInfoDataModelValue.space_needs_be_confirmed"
                                     :space-id="spaceInfoDataModelValue.space_id"></ConfirmationRequirementText>

        <SpaceIntroduction :introduction="spaceInfoDataModelValue.introduction"></SpaceIntroduction>
        <hr>
        <SpaceEquipment :space-equipment="equipmentArray"></SpaceEquipment>
        <hr>
        <SpaceServices :space-services="servicesArray"></SpaceServices>
        <hr>


        <!--        <SpaceRentNote :space-opening-times="spaceInfoDataModelValue.opening_times"
                               :shortest-rental-duration="shortestRentalDurationFromRent"
                               :space-rent="spaceInfoDataModelValue.rent"
                               :advance-booking-days="spaceInfoDataModelValue.advance_booking_days"
                               :brand-name="spaceInfoDataModelValue.brand_name"
                               :admin-id="spaceInfoDataModelValue.admin_id"
                               v-model:selected-rent-group="selectedRentGroup"
                               v-model:rent-selected-index="rentSelectedIndex"/>-->

        <!-- 直接轉跳廠商官網 -->
        <div v-if="spaceLinkToWebsite[spaceIdModelValue]"
             class="mt-10 flex items-center justify-center w-full h-[50px] text-[18px]
         font-bold rounded-[50px] text-osn-dark-grey-00 bg-osn-yellow-00 cursor-pointer"
             @click="goReservation">
          {{ '立即前往預訂' }}
        </div>

        <SpaceRentWrapper v-else
                          :space-opening-times="spaceInfoDataModelValue.opening_times"
                          :shortest-rental-duration="shortestRentalDurationFromRent"
                          :space-rent="spaceInfoDataModelValue.rent"
                          :advance-booking-days="spaceInfoDataModelValue.advance_booking_days"
                          :space-usage-status="spaceInfoDataModelValue.space_usage_status"
                          :space-accessories="spaceInfoDataModelValue.accessories"
                          :can-reservation="spaceInfoDataModelValue.can_reservation"
                          :space-info-obj="spaceInfoDataModelValue"
                          :space-id="spaceIdModelValue"
                          v-model:selected-rent-group="selectedRentGroup"
                          v-model:rent-selected-index="rentSelectedIndex"
                          :need-be-confirm="spaceInfoDataModelValue.space_needs_be_confirmed"></SpaceRentWrapper>
        <SpaceLine :admin-id="spaceInfoDataModelValue.admin_id"></SpaceLine>

        <!--        <SpaceReserveInfo></SpaceReserveInfo>-->
        <!--        <SpaceRoomSize :space-max-people="spaceInfoDataModelValue.number_of_people_max"
                               :space-room-size="spaceInfoDataModelValue.room_size"></SpaceRoomSize>-->


<!--        yt 影片測試-->
<!--        <hr class="my-4">
        <div class="relative overflow-hidden w-full max-w-[560px] py-4 mx-auto pc:h-[400px] mobile:pb-[56.25%] mobile:h-0">
          <iframe
              class="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/8zjP9tuNtS8?rel=0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen>
          </iframe>
        </div>-->
        <div>
          <hr class="my-4" />
          <div
              v-if="videoUrl"
              class="relative overflow-hidden w-full max-w-[560px] py-4 mx-auto pc:h-[400px] mobile:pb-[56.25%] mobile:h-0"
          >
            <iframe
                class="absolute top-0 left-0 w-full h-full"
                :src="videoUrl"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
            ></iframe>
          </div>
        </div>



        <SpacePhotoAll :space-photo-obj="spaceInfoDataModelValue.photos"
                       :space-name="spaceInfoDataModelValue.name"></SpacePhotoAll>
        <SpaceMap :space-location="spaceInfoDataModelValue.location"
                  ref="refMap"></SpaceMap>
        <!--        <SpaceCalendar :space-usage-status="spaceInfoDataModelValue.space_usage_status"
                               class="mt-5"></SpaceCalendar>-->

        <SpaceUseInfo v-if="parseRentMRT(spaceInfoDataModelValue.traffic)||spaceInfoDataModelValue.public_transport_info"
                      :info-title="$t('space.public_transport_info')"
                      :info-traffic-content="parseRentMRT(spaceInfoDataModelValue.traffic)"
                      :info-content="spaceInfoDataModelValue.public_transport_info"></SpaceUseInfo>

        <SpaceUseInfo v-if="spaceInfoDataModelValue.driving_info"
                      :info-title="$t('space.driving_info')"
                      :info-content="spaceInfoDataModelValue.driving_info"></SpaceUseInfo>

        <SpaceUseInfo v-if="spaceInfoDataModelValue.parking_info"
                      :info-title="$t('space.parking_info')"
                      :info-content="spaceInfoDataModelValue.parking_info"></SpaceUseInfo>

        <SpaceUseInfo :info-title="$t('space.rule')"
                      :info-content="spaceInfoDataModelValue.term_of_use"></SpaceUseInfo>

        <SpaceRefundPolicy :refund-policy="spaceInfoDataModelValue.refund_policy"></SpaceRefundPolicy>

        <div class="info-pair-wrap">
          <div>{{ $t('space.brand') }}</div>
          <h2 class="underline point"
              @click="searchAdmin(spaceInfoDataModelValue.admin_id)">
            {{ spaceInfoDataModelValue.brand_name }}
          </h2>
        </div>

      </div>
    </div>

  </div>

</template>

<script setup>
import {computed, nextTick, onMounted, ref} from "vue";
import {ArrowLeft} from '@element-plus/icons-vue'

import {useSpaceInfoStore} from "@/stores/spaceInfo";
import {useSettingStore} from '@/stores/setting'
import {parseRentMRT} from "@/utils/parseTool.js";
import {getSpaceInfo} from "@/api/space";
import {User} from '@element-plus/icons-vue'

import SpacePhotoSwiper from "@/components/SpaceDetail/SpacePhotoSwiper.vue";
import SpacePriceWrapper from "@/components/SpaceDetail/SpacePriceWrapper.vue";
import ConfirmationRequirementText from "@/components/SpaceDetail/ConfirmationRequirementText.vue";
import SpaceRentNote from "@/components/SpaceDetail/SpaceRentNote.vue";
import SpaceRentWrapper from "@/components/SpaceDetail/SpaceRentWrapper.vue";
import SpaceIntroduction from "@/components/SpaceDetail/SpaceIntroduction.vue";
import SpaceReserveInfo from "@/components/SpaceDetail/SpaceReserveInfo.vue";
import SpaceRoomSize from "@/components/SpaceDetail/SpaceRoomSize.vue";
import SpaceEquipment from "@/components/SpaceDetail/SpaceEquipment.vue";
import SpaceServices from "@/components/SpaceDetail/SpaceServices.vue";
import SpacePhotoAll from "@/components/SpaceDetail/SpacePhotoAll.vue";
import SpaceMap from "@/components/SpaceDetail/SpaceMap.vue";
import SpaceUseInfo from "@/components/SpaceDetail/SpaceUseInfo.vue";
import SpaceRefundPolicy from "@/components/SpaceDetail/SpaceRefundPolicy.vue";
import {getMinShortestRentalDuration} from "~/utils/newPriceTool.ts";
import {useGoTo} from "@/composables/useGoTo";
import {spaceLinkToWebsite} from "~/config/common.js";
import SpaceLine from "@/components/SpaceDetail/SpaceLine.vue";
import SpaceCalendar from "@/components/SpaceDetail/SpaceCalendar.vue";
import {useSearchQueryStore} from "~/stores/searchQuery";
import {useAdminSpaceSearch} from "~/composables/useAdminSpaceSearch";
import videoData from '@/config/youtube.json'

const searchQueryStore = useSearchQueryStore()
const settingStore = useSettingStore()
const spaceInfoStore = useSpaceInfoStore()
const router = useRouter()
const route = useRoute();
const {handleAdminSpaceSearch} = useAdminSpaceSearch()

const selectedRentGroup = defineModel('selectedRentGroup', {type: Object, default: null})
const rentSelectedIndex = defineModel('rentSelectedIndex', {type: Number, default: 0})

const spaceIdModelValue = defineModel('spaceId', {type: Number, default: -1})
const spaceInfoDataModelValue = defineModel('spaceInfoData', {type: Object, default: null})

const refMap = ref(null);
const typeCategoryId = ref(import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID)
const usageCategoryId = ref(import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID)
const tagCategoryId = ref(import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID)
const isMobile = computed(() => settingStore.isMobile);

const equipmentArray = computed(() => {
  const {equipments, custom_equipments} = spaceInfoDataModelValue.value;

  // 將 equipments 和 custom_equipments 組合成一個陣列
  let combinedArray = equipments
      .filter(e => e.amounts > 0)
      .concat(custom_equipments)
      .sort((a, b) => a.order - b.order);

  // 將 amounts 屬性設置為 equipment.amounts 或 equipment.amount 的值
  combinedArray.forEach(equipment => {
    equipment.amounts = equipment.amounts || equipment.amount;
  });
  return combinedArray;
});

const servicesArray = computed(() =>
    spaceInfoDataModelValue.value.services.filter(s => s.enable)
)

const shortestRentalDurationFromRent = computed(() => {
  // return spaceInfoDataModelValue.value.rent.find(r => r.type === 0)?.shortest_rental_duration ?? 0
  return getMinShortestRentalDuration(spaceInfoDataModelValue.value.rent.rent_groups) ?? 0
})

const videoUrl = computed(() => {
  const match = videoData.find(item => item.spaceId === spaceIdModelValue.value)
  return match ? `https://www.youtube.com/embed/${match.youtubeId}?rel=0` : null
})


// SSR 取得空間資料
/*if (spaceIdModelValue.value) {
  handleSpaceInfo()
}*/

/*async function handleSpaceInfo() {
  const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
  try {
    const {data: SpaceInfoData} = await useAsyncData('getSpaceInfo', () => getSpaceInfo(spaceIdModelValue.value, goHome));

    if (SpaceInfoData.value) {
      spaceInfoObj.value = SpaceInfoData.value

      setSeoMeta({
        title: `${SpaceInfoData.value.brand_name} ${SpaceInfoData.value.name}｜立即預約！onestep 空間便利店`,
        description: SpaceInfoData.value.introduction,
        keywords: `${getCategoryNamesString(SpaceInfoData.value.categories[Number(typeCategoryId.value)])} ${getCategoryNamesString(SpaceInfoData.value.categories[Number(usageCategoryId.value)])}`,
        ogTitle: `${SpaceInfoData.value.name}｜立即預約！onestep 空間便利店`,
        ogDescription: SpaceInfoData.value.introduction,
        ogImage: `${picUrl}${SpaceInfoData.value.photos[0].url}`,
        ogImageAlt: `${SpaceInfoData.value.name}｜立即預約！onestep 空間便利店`
      })
      /// space_usage_status 日期排序
      spaceInfoObj.value.space_usage_status.sort((a, b) => new Date(a.date) - new Date(b.date))

      spaceInfoObj.value.accessories.forEach(accessory => {
        accessory.ellipsis = true
        accessory.selected = false
      })

    }
  } catch (error) {

    router.push({query: {}})
    console.log(error)
  }
}*/


onMounted(() => {
  /// 時間轉 24+
  spaceInfoDataModelValue.value?.rent?.rent_groups?.forEach(rentGroup => {
    Object.values(rentGroup?.rent_types).forEach(rent_type => {
      Object.values(rent_type?.dates).forEach(date => {
        tuneCrossDay(date)
      })
      tuneCrossDay(rent_type?.holiday)
      Object.values(rent_type?.week_days).forEach(week_day => {
        tuneCrossDay(week_day)
      })
    })
  })

  if (spaceIdModelValue.value) {
    spaceInfoStore.updateSpaceID(spaceIdModelValue.value)
  }
  if (settingStore.isShowLog) {
    console.log('spaceInfoDataModelValue = ', spaceInfoDataModelValue.value);
  }
})


const scrollToMap = () => {
  nextTick(() => {
    if (refMap.value) {
      const element = refMap.value.$el || refMap.value
      element.scrollIntoView({behavior: 'smooth'})
    }
  })
}

function handleSpaceTypeArray(categories) {
  categories = categories || []
  return categories[typeCategoryId.value]
}

function handleSpaceUsageArray(categories) {
  categories = categories || []
  return categories[usageCategoryId.value]
}

function handleSpaceTagArray(categories) {
  categories = categories || []
  return categories[tagCategoryId.value]
}

function setSeoMeta(seoMeta) {
  useSeoMeta(seoMeta)
}

function getCategoryNamesString(categories) {
  return categories.map(category => category.name).join(' ')
}


function goReservation() {

  if (spaceIdModelValue?.value && spaceLinkToWebsite[spaceIdModelValue.value]) {
    window.open(spaceLinkToWebsite[spaceIdModelValue.value])
  } else {
    if (settingStore.isShowLog) {
      console.log('轉跳廠商官網 goReservation space id = ', spaceIdModelValue.value)
    }
  }
}


function searchAdmin(adminId) {
  if (route.path === '/space-detail' || route.path === '/space/' + route.params.spaceid) {
    searchQueryStore.initQueryDate()
    handleAdminSpaceSearch(adminId)
    router.push({path: '/search-result'})

  } else {
    router.back()
  }

}


</script>
<style scoped
       lang="scss">
.ol .ul .menu {
  padding: 10px;
}

.space-detail {
  @apply w-full h-full bg-white rounded-[10px];
  .brand-name {
    @apply h-[55px] leading-[55px] text-center text-[22px] font-medium relative;
  }

  .space-info-scroll {
    .img-wrap {
      @apply relative cursor-pointer;
      img {
        @apply rounded-[10px] aspect-[1024/683] max-w-[100%];
      }
    }

    .space-info-wrap {
      @apply flex flex-col p-[20px];
      .name {
        @apply mb-[2px] text-[22px] text-black;
      }

      .address {
        @apply flex items-center mb-[4px] text-[18px] text-osn-grey-01;
        img {
          @apply w-[16px] h-[16px] ml-[4px];
        }
      }

      .traffic {
        @apply flex items-center mb-[4px] text-[14px] text-black;
        img {
          @apply w-[16px] h-[16px] mr-[4px];
        }
      }

      .tag {
        @apply px-[8px] py-[2px] h-[24px] leading-[20px] text-[12px] text-white mr-[4px] rounded-[50px];
      }

      .divider {
        @apply w-full h-[1px] border-b border-gray-300 mt-[10px] mb-[14px];
      }


      .info-pair-wrap {
        @apply mt-5 flex items-start text-[15px] mb-[4px];
        > div:nth-child(1) {
          @apply w-[77px]
        }

        > div:nth-child(2) {
          @apply text-osn-dark-grey-00;
        }
      }
    }
  }
}
</style>
